import { Box, Stack, Typography } from '@mui/material';
import CKEditorResult from '@/components/common/CKEditorResult';

const BlogDetailsSection = ({ blog = {} }) => {
  return (
    <>
      <Stack gap={{ xs: 2, sm: 4, md: 5 }} width="100%">
        <Box>
          <Typography
            fontWeight={600}
            fontSize={{ xs: 22, sm: 28, md: 39 }}
            lineHeight={{ xs: '30px', sm: '40px', md: '50px' }}
            textAlign="center">
            {blog.title}
          </Typography>
          <Typography
            fontWeight={500}
            fontSize={{ xs: 16, sm: 20, md: 23 }}
            lineHeight={{ xs: '24px', sm: '30px', md: '40px' }}
            textAlign="center"
            color="text.secondary"
            mt={{ xs: 1, sm: 1, md: 1 }}>
            {blog.subtitle}
          </Typography>
        </Box>
        <CKEditorResult
          content={blog.content}
          title={blog.title}
          type="مقاله"
        />
      </Stack>
    </>
  );
};

export default BlogDetailsSection;
